import HallsTable from "./halls-table";

export default HallsTable;
